import { render, staticRenderFns } from "./DeviceStock.vue?vue&type=template&id=7a7647b6&scoped=true"
import script from "./DeviceStock.vue?vue&type=script&lang=js"
export * from "./DeviceStock.vue?vue&type=script&lang=js"
import style0 from "./DeviceStock.vue?vue&type=style&index=0&id=7a7647b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7647b6",
  null
  
)

export default component.exports